import React from "react";
import Link from "next/link";
import { getAssets } from "@unisearch/helpers";
import PlayButtonWithRipple from "@modules/study/common/play_btn_with_ripple";
import styles from "./blog_box_grid.module.scss";
import Image from "next/image";

const BlogBoxGrid = ({
  spanTwoWithOverlay,
  colorWhite,
  blogTitle,
  blogLink,
  categories,
  featureImage,
  videoType,
  summary,
}) => {
  return (
    <div
      className={`${styles.box_grid} ${
        spanTwoWithOverlay ? `${styles.span_two_with_overlay}` : ""
      } `}
    >
      <div className={`${styles.image_wrapper} relative`}>
        {videoType && (
          <Link legacyBehavior href={blogLink}>
            <a>
              <PlayButtonWithRipple
                medium={!spanTwoWithOverlay}
                ripple={false}
              />
            </a>
          </Link>
        )}
        <Link href={blogLink || "#"}>
          <Image
            blurDataURL={getAssets("assets/images/image_placeholder_big.webp")}
            placeholder="blur"
            src={
              featureImage ||
              getAssets("assets/images/image_placeholder_big.webp")
            }
            alt={blogTitle}
            width={800}
            height={500}
          />
        </Link>
      </div>

      <div className={styles.blog_info}>
        {categories && categories?.length > 0 && (
          <div className={styles.category}>
            {categories?.map((cat, i, row) => {
              return (
                <Link
                  legacyBehavior
                  href={`/blog/category/${cat?.slug}`}
                  key={`cat${i}`}
                >
                  <a className={styles.blog_cat_title}>
                    {cat?.title}
                    {row.length === ++i ? null : ", "}
                  </a>
                </Link>
              );
            })}
          </div>
        )}

        <Link legacyBehavior href={blogLink || "#"}>
          <a style={{ display: "block" }}>
            <h3
              className={`${styles.blog_title} ${
                colorWhite ? `${styles.color_white}` : ""
              } `}
            >
              {blogTitle}
            </h3>
          </a>
        </Link>
        {summary && (
          <>
            {spanTwoWithOverlay && (
              <div className={styles.blog_description}>{summary}</div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default BlogBoxGrid;
